import { render, staticRenderFns } from "./supported-players.vue?vue&type=template&id=45b0b79d&"
import script from "./supported-players.vue?vue&type=script&lang=js&"
export * from "./supported-players.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports